import Home from './Home.svelte'
import FishSETMap from './FishSETMap.svelte'
import Lost from './Lost.svelte'
import TSAThroughput from './TSAThroughput.svelte'
// import VesselMap from './VesselMap.svelte'
import Howibuiltit from './Howibuiltit.svelte'
// import Map from "./Map.svelte"
import PointMap from "./PointMap.svelte"


// Export the route definition object
export default {
    // Exact path
    '/': Home,

    // Using named parameters, with last being optional
    '/FishSETMap': FishSETMap,
    '/TSACheckpoint':TSAThroughput,
    '/VesselMap':PointMap,
    '/How':Howibuiltit,
    // '/Map':Map,
    // '/PointMap':PointMap,


    // Catch-all, must be last
     '*': Lost,
}